import React from "react";
import "./GalleryStrip.css";

/**
 * 3-column image strip with hover-zoom.
 * Props:
 *   images — array of 3 image URLs
 *   title  — optional label above strip
 */
function GalleryStrip({ images = [], title }) {
  return (
    <div className="gallery-strip">
      {title && <p className="gallery-strip__label">{title}</p>}
      <div className="gallery-strip__grid">
        {images.map((src, i) => (
          <div key={i} className="gallery-strip__cell">
            <img src={src} alt={`Gallery  ${i + 1}`} className="gallery-strip__img" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default GalleryStrip;
